export function BaseService() {
  abstract class BaseService {
    static entityPath: string
  }

  return BaseService
}
